import { render, staticRenderFns } from "./elevator-test.vue?vue&type=template&id=159a5a0b&scoped=true&"
import script from "./elevator-test.vue?vue&type=script&lang=js&"
export * from "./elevator-test.vue?vue&type=script&lang=js&"
import style0 from "./elevator-test.vue?vue&type=style&index=0&id=159a5a0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159a5a0b",
  null
  
)

export default component.exports